module.exports = __webpack_public_path__ + "summernote.372a2830643e759ed61f.eot";


//////////////////
// WEBPACK FOOTER
// /builds/faixa-azul/faixa-azul-fad-web/node_modules/summernote/dist/font/summernote.eot?0d0d5fac99cc8774d89eb08b1a8323c4
// module id = ../../../../summernote/dist/font/summernote.eot?0d0d5fac99cc8774d89eb08b1a8323c4
// module chunks = styles